import {
  ContentBlock,
  Heading,
  Stack,
  Columns,
  Column,
  Box,
  Strong,
} from 'braid-design-system';
import React, { type ReactNode } from 'react';

interface Props {
  title: string;
  children: ReactNode;
  className: any;
  reverse?: boolean;
}

export const ImageTextComponent = ({
  title,
  children,
  className,
  reverse = true,
}: Props) => (
  <ContentBlock>
    <Box position="relative" paddingX={{ mobile: 'small', tablet: 'none' }}>
      <Columns
        collapseBelow="tablet"
        reverse={!reverse}
        space={['large', 'xxlarge']}
        alignY="center"
      >
        <Column width="1/2">
          <Box style={{ maxWidth: '500px' }}>
            <Stack space="large">
              <Box
                textAlign={{
                  mobile: 'center',
                  desktop: 'left',
                  tablet: 'left',
                }}
                style={{ textWrap: 'balance' }}
              >
                <Heading level="2">
                  <Strong>{title}</Strong>
                </Heading>
              </Box>
              <>{children}</>
            </Stack>
          </Box>
        </Column>
        <Column width="1/2">
          <Box className={className} />
        </Column>
      </Columns>
    </Box>
  </ContentBlock>
);
